export default (
  <>
    <path
      d="M8.56111 6.54042C8.16076 6.54042 7.83621 6.86497 7.83621 7.26533C7.83621 7.66568 8.16076 7.99023 8.56111 7.99023H15.8102C16.2105 7.99023 16.5351 7.66568 16.5351 7.26533C16.5351 6.86497 16.2105 6.54042 15.8102 6.54042H8.56111Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.85157 3.85157C5.39682 3.30632 6.13634 3 6.90744 3H19.2751C19.6754 3 20 3.32455 20 3.72491V18.2751C20 18.6754 19.6754 19 19.2751 19H6.90744C6.52085 19 6.1501 19.1536 5.87674 19.4269C5.60339 19.7003 5.44982 20.071 5.44982 20.4576V20.4602H17.8201C18.2204 20.4602 18.545 20.7848 18.545 21.1851C18.545 21.5855 18.2204 21.91 17.8201 21.91H4.72491C4.32455 21.91 4 21.5855 4 21.1851V5.90744C4 5.13634 4.30632 4.39682 4.85157 3.85157ZM5.44982 17.942C5.88897 17.6875 6.39112 17.5502 6.90744 17.5502H18.5502V4.44982H6.90744C6.52085 4.44982 6.1501 4.60339 5.87674 4.87674C5.60339 5.1501 5.44982 5.52085 5.44982 5.90744V17.942Z"
      fill="currentColor"
    />
  </>
);
